import { createTheme } from '@mui/material/styles'
import { esES } from '@mui/material/locale'

export const theme =
    createTheme({
        palette: {
            primary: {
                light: '#a5d274',
                main: '#9BCD65',
                dark: '#8bb85a',
                contrastText: '#000000',
            },
        },
        components: {
            MuiTextField: {
                defaultProps: {
                    variant: "outlined",
                    fullWidth: true
                },
            },
            MuiButton: {
                defaultProps: {
                    variant: "contained",
                    color: "primary",
                },
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: {
                        backgroundColor: "#833",
                        color: "white"
                    },
                }
            },
            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: "#9BCD65",
                            color: "black",
                            fontSize: 14,
                        },
                        '& 	.MuiDataGrid-row': {
                            fontSize: 12,
                        },

                        "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle": {
                            textOverflow: "clip",
                            whiteSpace: "break-spaces",
                            lineHeight: 1
                        },
                        '& .MuiDataGrid-iconSeparator': {
                            display: "none"
                        },
                        '& .Mui-error': {
                            backgroundColor: '#ff9191',
                        }
                    }
                }
            }
        },
    }, esES)